import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Header } from '../components/Header';
import { apiService } from '../services/api';
import type { ContactLabel } from '../types';

export function ContactLabelsPage() {
  const [labels, setLabels] = useState<ContactLabel[]>([]);
  const [name, setName] = useState('');
  const [color, setColor] = useState('#2563eb');
  const [editingId, setEditingId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try { setLabels(await apiService.getContactLabels()); }
    catch (error) { toast.error(error instanceof Error ? error.message : 'Erro ao carregar etiquetas'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const reset = () => { setName(''); setColor('#2563eb'); setEditingId(null); };
  const save = async () => {
    if (!name.trim() || saving) return;
    setSaving(true);
    try {
      if (editingId) await apiService.updateContactLabel(editingId, { name: name.trim(), color });
      else await apiService.createContactLabel({ name: name.trim(), color });
      toast.success(editingId ? 'Etiqueta atualizada' : 'Etiqueta criada');
      reset(); await load();
    } catch (error) { toast.error(error instanceof Error ? error.message : 'Erro ao salvar etiqueta'); }
    finally { setSaving(false); }
  };

  const remove = async (label: ContactLabel) => {
    if (!window.confirm(`Excluir a etiqueta "${label.name}" de todos os contatos?`)) return;
    try { await apiService.deleteContactLabel(label.id); await load(); toast.success('Etiqueta excluida'); }
    catch (error) { toast.error(error instanceof Error ? error.message : 'Erro ao excluir etiqueta'); }
  };

  return <>
    <Header title="Etiquetas de contatos" subtitle="Crie etiquetas para organizar e filtrar seus contatos" />
    <div className="p-4 sm:p-6 space-y-5">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
          <label className="flex-1 text-sm font-medium text-gray-700">Nome
            <input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && save()} placeholder="Ex.: Cliente VIP" className="input-field mt-1" />
          </label>
          <label className="text-sm font-medium text-gray-700">Cor
            <input type="color" value={color} onChange={(e) => setColor(e.target.value)} className="mt-1 block h-10 w-16 cursor-pointer rounded border border-gray-300 bg-white p-1" />
          </label>
          <button type="button" onClick={save} disabled={!name.trim() || saving} className="btn-primary disabled:opacity-50">{editingId ? 'Salvar alteracoes' : '+ Criar etiqueta'}</button>
          {editingId && <button type="button" onClick={reset} className="rounded-lg border px-4 py-2 text-sm">Cancelar</button>}
        </div>
      </div>
      <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
        {loading ? <div className="p-8 text-center text-gray-500">Carregando...</div> : labels.length === 0 ? <div className="p-8 text-center text-gray-500">Nenhuma etiqueta criada.</div> : labels.map((label) => (
          <div key={label.id} className="flex items-center gap-3 border-b border-gray-100 p-4 last:border-0">
            <span className="h-4 w-4 rounded-full" style={{ backgroundColor: label.color }} />
            <span className="flex-1 font-medium text-gray-800">{label.name}</span>
            <button type="button" onClick={() => { setEditingId(label.id); setName(label.name); setColor(label.color); }} className="text-sm text-blue-600">Editar</button>
            <button type="button" onClick={() => remove(label)} className="text-sm text-red-600">Excluir</button>
          </div>
        ))}
      </div>
    </div>
  </>;
}
